import { render } from "./EditUser.vue?vue&type=template&id=6249a628"
import script from "./EditUser.vue?vue&type=script&lang=ts"
export * from "./EditUser.vue?vue&type=script&lang=ts"
script.render = render

export default script